<template>
  <div class="mouse-hover-wrapper">
    <div class="wrapper">
      <slot></slot>
    </div>

    <div class="popover-wrapper" v-if="$slots.popover">
      <slot name="popover"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.mouse-hover-wrapper {
  position: relative;
  cursor: pointer;
  transition: all 0.2s;
  // 占位不然hover不到popover就消息了
  &::before{
    content: '';
    position: absolute;
    width: 24px;
    height: 100%;
    right: 100%;
    top: 0;
    z-index: 0;
  }
  .popover-wrapper {
    z-index: -1;
    position: absolute;
    right: 100%;
    top: 50%;
    background-color: #fff;
    transform: translate(-24px, -50%);
    visibility: hidden;
    opacity: 0;
    box-shadow: 0px 3px 16px 0px rgba(30,43,61,0.12);
    &::after {
      content: "";
      width: 0;
      height: 0;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translate(100%, -50%);
      border-top: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 8px solid transparent;
      border-left: 8px solid #fff;
    }
  }
  &:hover {
    .popover-wrapper {
      visibility: visible;
      opacity: 1;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/fixed-right-service/components/service-list/components/mouse-hover-wrapper.vue